import React, { Fragment } from 'react';
import { StarPicker } from 'react-star-picker';
import styled from 'styled-components';
import { WebsiteImage } from 'components/TitleDescription';

const HeroSocialProof = ({ reviews, background }) => {
  let correctOrder = []; //'Google, capterra, software advice'
  reviews.companyLogos.map(ele => {
    if (ele.internalName.includes('Google')) {
      correctOrder[0] = ele;
    } else if (ele.internalName.includes('Capterra')) {
      correctOrder[1] = ele;
    } else if (ele.internalName.includes('Advice')) {
      correctOrder[2] = ele;
    }
  });
  return (
    <Fragment>
      <ReviewsStyled background={background} className="test-hero-social-proof-1">
        <StarPicker
          name="rating1"
          className="hero-social-proof--rate-star"
          value={reviews.stars}
          halfStars
          disabled
          size={40}
          starRendererProps={{
            colorActive: reviews.starColor,
            colorInactive: reviews.starOffColor,
          }}
        />
        <p className="hero-social-proof--rate-description">{reviews.title}</p>
      </ReviewsStyled>
      {reviews.companyLogos && (
        <LogosStyled className="shero-social-proof--rate-logo-content test-hero-social-proof-2">
          {correctOrder.map((item, index) => {
            return (
              <div className="shero-social-proof--rate-logo-item" key={index}>
                <WebsiteImage src={item.image.file.url} />
              </div>
            );
          })}
        </LogosStyled>
      )}
    </Fragment>
  );
};

export default HeroSocialProof;

HeroSocialProof.propTypes = {};

HeroSocialProof.defaultProps = {};

const ReviewsStyled = styled.div`
  display: flex;
  margin-top: 40px;
  align-items: center;

  .hero-social-proof--rate-star {
    .StarPickerButton {
      line-height: 52px;
      cursor: default;

      &.halfStars:nth-child(2n + 1) {
        margin-left: 0px;
      }
      &.halfStars:nth-child(2n) {
        margin-right: 8px;
      }
    }
  }

  .hero-social-proof--rate-description {
    font-size: 16px;
    line-height: 42px;
    color: ${props => (props.background === 'White' ? 'black' : 'white')};
    margin: 0 0 0 18px;
  }

  @media (max-width: 991px) {
    .hero-social-proof--rate-star {
      .StarPickerButton {
        line-height: 42px;
        cursor: default;
        width: 15px;
        font-size: 30px;

        &.halfStars:nth-child(2n + 1) {
          margin-left: 0px;
        }
        &.halfStars:nth-child(2n) {
          margin-right: 8px;
        }

        & > .StarPickerButton-buttonContent {
          width: 30px;
        }
      }
    }

    .hero-social-proof--rate-description {
      font-size: 16px;
      line-height: 42px;
      margin: 0 0 0 18px;
    }
  }

  @media (max-width: 690px) {
    .hero-social-proof--rate-star {
      .StarPickerButton {
        width: 12px;
        font-size: 24px;

        & > .StarPickerButton-buttonContent {
          width: 24px;
        }
      }
    }
    .hero-social-proof--rate-description {
      font-size: 15px;
      margin: 0 0 0 14px;
    }
  }
  @media (max-width: 610px) {
    .hero-social-proof--rate-star {
      .StarPickerButton {
        width: 11px;
        font-size: 22px;

        & > .StarPickerButton-buttonContent {
          width: 22px;
        }
      }
    }
    .hero-social-proof--rate-description {
      font-size: 14px;
      margin: 0 0 0 12px;
    }
  }
  @media (max-width: 575px) {
    .hero-social-proof--rate-star {
      .StarPickerButton {
        width: 15px;
        font-size: 30px;

        & > .StarPickerButton-buttonContent {
          width: 30px;
        }
      }
    }
    .hero-social-proof--rate-description {
      font-size: 16px;
      margin: 0 0 0 18px;
    }
  }
`;

const LogosStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 28px;
  max-width: 419px;

  .shero-social-proof--rate-logo-item {
    margin-right: 32px;
    display: flex;

    img {
      max-width: 100%;
    }

    &:last-child {
      margin-right: 0;
    }
  }
  @media (max-width: 991px) {
    margin-top: 18px;

    .shero-social-proof--rate-logo-item {
      margin-right: 20px;
    }
  }
  @media (max-width: 695px) {
    display: flex;
    align-items: center;
    margin-top: 28px;

    .shero-social-proof--rate-logo-item {
      margin-right: 27px;

      &:last-child {
        margin-right: 0;
      }

      img {
        max-width: 100%;
      }
    }
  }
`;
